<template>
  <div :class="classes">
    <div class="vi-sidebar-sublevel-item--title" @click="isShow = !isShow">
      <span class="vi-sidebar-sublevel-item--title__icon hfs">&#xe60c;</span>
      <span class="vi-sidebar-sublevel-item--title__text">{{item.reMenu}}</span>
      <span class="vi-sidebar-sublevel-item--title__tar"><i class="el-icon-arrow-down"></i></span>
    </div>
    <el-collapse-transition>
      <div v-if="isShow">
        <m-sidebar-sub-item :item="el" v-for="(el,$index) in item.children" :key="$index"/>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import mSidebarSubItem from './sidebarSubItem'
  import { isSelectMenu } from './utils'

  const prefixCls = 'vi-sidebar-sublevel-item'
  export default {
    name: 'vi-sidebar-sublevel-item',
    data () {
      return {
        isShow: false
      }
    },
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    },
    methods: {},
    watch: {},
    beforeCreate () {
    },
    created () {
      const ids = _.map(this.item.children, 'reUrl')
      this.isShow = isSelectMenu(this.currentParentPath, ids)
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['currentParentPath']),
      classes () {
        return [
          `${prefixCls}`
        ]
      }
    },
    components: { mSidebarSubItem }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  $-prefix-cls: "vi-sidebar-sublevel-item";
  .#{$-prefix-cls} {
    &--title {
      margin: 0px 6px;
      height: 42px;
      line-height: 40px;
      transition: all 0.2s ease-out;
      position: relative;
      z-index: 1;
      cursor: pointer;
      border-radius:4px;
      &:hover {
        transition: all 0.2s ease-out;
        background-color: #EDF2FD;
      }
      &__icon {
        color: rgb(74, 74, 74);
        font-size: 16px;
        padding-left: 6px;
      }
      &__text {
        font-size: 14px;
        color: rgb(74, 74, 74);
        padding-left: 0px;
      }
      &__tar {
        position: absolute;
        right: 6px;
        top: 0;
        z-index: 0;
        >i {
          color: #909399;
          font-size: 12px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/sidebarSublevelItem.vue